import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, DateField, enumField, listField } from './util';
import { File } from './file';
import { User, UserGender } from './user';
import { LeaguePlayerFieldValue } from './league-player-field-value';
import { Locales } from '../localization/locales';

export enum Qualification {
  practician = 1,
  amateur,
  practician2,
  practician3,
  amateur2,
  theorist,
  theorist2,
  theorist3,
  sportsman,
  lider,
  master,
  profi,
  goalkeeper,
  goalkeeper2,
  goalkeeper_sh,
  goalkeeper_ul,
  goalkeeper_mhl,
  goalkeeper_vhl,
  goalkeeper_khl,
  beginner,
  junior,
  debutant,
  schoolchild,
  preschool_child
}

export const QualificationLocalization = {
  [Locales.ru]: {
    [Qualification.practician]: 'Практик',
    [Qualification.practician2]: 'Практик 2',
    [Qualification.practician3]: 'Практик 3',
    [Qualification.amateur]: 'Любитель',
    [Qualification.amateur2]: 'Любитель 2',
    [Qualification.theorist]: 'Теоретик',
    [Qualification.theorist2]: 'Теоретик 2',
    [Qualification.theorist3]: 'Теоретик 3',
    [Qualification.sportsman]: 'Спортсмен',
    [Qualification.lider]: 'Лидер',
    [Qualification.master]: 'Мастер',
    [Qualification.profi]: 'Профи',
    [Qualification.goalkeeper]: 'Вратарь',
    [Qualification.goalkeeper2]: 'Вратарь 2',
    [Qualification.goalkeeper_sh]: 'Вратарь СШ',
    [Qualification.goalkeeper_ul]: 'Вратарь ЮЛ',
    [Qualification.goalkeeper_mhl]: 'Вратарь МХЛ',
    [Qualification.goalkeeper_vhl]: 'Вратарь ВХЛ',
    [Qualification.goalkeeper_khl]: 'Вратарь КХЛ',
    [Qualification.beginner]: 'Новичок',
    [Qualification.junior]: 'Юниор',
    [Qualification.debutant]: 'Дебютант',
    [Qualification.schoolchild]: 'Школьник',
    [Qualification.preschool_child]: 'Дошкольник',
  },
  [Locales.en]: {
    [Qualification.practician]: 'Practician',
    [Qualification.practician2]: 'Practician 2',
    [Qualification.practician3]: 'Практик 3',
    [Qualification.amateur]: 'Amateur',
    [Qualification.amateur2]: 'Amateur 2',
    [Qualification.theorist]: 'Theorist',
    [Qualification.theorist2]: 'Theorist 2',
    [Qualification.theorist3]: 'Theorist 3',
    [Qualification.sportsman]: 'Sportsman',
    [Qualification.lider]: 'Leader',
    [Qualification.master]: 'Master',
    [Qualification.profi]: 'Professional',
    [Qualification.goalkeeper]: 'Goalkeeper',
    [Qualification.goalkeeper2]: 'Goalkeeper 2',
    [Qualification.goalkeeper_sh]: 'Goalkeeper SH',
    [Qualification.goalkeeper_ul]: 'Goalkeeper UL',
    [Qualification.goalkeeper_mhl]: 'Goalkeeper MHL',
    [Qualification.goalkeeper_vhl]: 'Goalkeeper VHL',
    [Qualification.goalkeeper_khl]: 'Goalkeeper KHL',
    [Qualification.beginner]: 'Beginner',
    [Qualification.junior]: 'Junior',
    [Qualification.debutant]: 'Debutant',
    [Qualification.schoolchild]: 'Schoolchild',
    [Qualification.preschool_child]: 'Preschool child',
  }
};


@ModelInstance({
  mappingFields: {
    id: 'id',
    user_id: 'userId',
    league_id: 'leagueId',
    first_name: 'firstName',
    last_name: 'lastName',
    middle_name: 'middleName',
    birth_date: 'birthDate',
    photo: 'photo',
    user: 'user',
    gender: 'gender',
    has_changes: 'hasChanges',
    rating: 'rating',
    qualification: 'qualification',
    field_values: 'fieldValues',
  },
  relation: {
    birthDate: DateField,
    photo: File,
    user: User,
    qualification: enumField(Qualification),
    fieldValues: listField(LeaguePlayerFieldValue),
    gender: enumField(UserGender),
  }
})
export class LeaguePlayer extends BaseModel {
  id: number;
  userId: number;
  leagueId: number;
  firstName: string;
  lastName: string;
  middleName: string;
  birthDate: Date;
  photo: File;
  user: User;
  gender: UserGender;
  hasChanges: boolean;
  rating: string;
  qualification: Qualification;
  fieldValues: LeaguePlayerFieldValue[];

  get fullName(): string {
    return [this.lastName, this.firstName, this.middleName].filter(s => s).join(' ');
  }

  get shortName(): string {
    return [this.lastName, this.firstName].filter(s => s).join(' ');
  }

  get initials(): string {
    return [this.lastName, this.firstName].filter(s => s).map(s => s.substr(0, 1)).join('');
  }

  get age(): number {
    if (!this.birthDate) {
      return null;
    }
    const diff = (new Date()).getTime() - this.birthDate.getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  }

  @ToFrontHook
  static toFront(data: any): any {
  }

  @ToBackHook
  static toBack(data: any): any {
  }
}
